import { Button } from '@/components/ui/button';
import { useState } from 'react';
import DestructiveActionsDialog from './destructive-actions-dialog';

export default function DangerZone() {
    const [isOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<'delete' | 'deactivate'>('delete');
    return (
        <div className='min-h-screen p-2 md:p-6'>
            <div className='mx-auto pb-16'>
                <div className='sm:max-w-5xl mx-auto'>
                    <h1 className='text-[clamp(0.8rem,5vw,1.8rem)] font-bold mb-8'>
                        Danger Zone
                    </h1>

                    <div className='prose prose-lg max-w-none'>
                        <p className='text-muted-foreground mb-8'>
                            These actions are irreversible. Please proceed with
                            caution and ensure you have backed up any important
                            data before continuing.
                        </p>

                        <div className='space-y-8'>
                            <div className='bg-card rounded-lg border border-destructive/20 p-2 md:p-8'>
                                <h2 className='text-[clamp(0.7rem,5vw,1.8rem)] font-semibold mb-4 text-destructive'>
                                    Destructive Actions
                                </h2>
                                <div className='space-y-6 sm:w-[90%] mx-auto'>
                                    <div className='flex flex-col lg:flex-row items-center justify-between gap-4 p-2 sm:p-4 bg-warning/20 rounded-lg border border-warning/20'>
                                        <div>
                                            <h3 className='text-lg font-medium text-warning'>
                                                Deactivate Account
                                            </h3>
                                            <p className='text-sm text-warning mt-1'>
                                                Deactivate your account for a
                                                while. <br />
                                                Your account will not be show
                                                up. You can restore your account
                                                later.
                                            </p>
                                        </div>
                                        <Button
                                            className='bg-warning hover:bg-warning/80'
                                            onClick={() => {
                                                setIsOpen(true);
                                                setAction('deactivate');
                                            }}>
                                            Deactivate Account
                                        </Button>
                                    </div>

                                    <div className='flex flex-col lg:flex-row gap-4 items-center justify-between p-2 sm:p-4 bg-destructive/10 rounded-lg border border-destructive/20'>
                                        <div>
                                            <h3 className='text-lg font-medium text-destructive'>
                                                Delete Account
                                            </h3>
                                            <p className='text-sm text-destructive mt-1'>
                                                Permanently delete your account
                                                and all associated data. This
                                                action cannot be undone.
                                            </p>
                                        </div>
                                        <Button
                                            variant='destructive'
                                            onClick={() => {
                                                setIsOpen(true);
                                                setAction('delete');
                                            }}>
                                            Delete Account
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DestructiveActionsDialog
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                action={action}
            />
        </div>
    );
}
